
export { userInfoDecodedDataAtom } from "/home/runner/work/capsicum/capsicum/libs/common/data-access/index.ts"